import {
  createAdminMessage,
  createMessage,
  createMessages,
  SB,
} from '@play-co/replicant';
import schema from '../../schema';
import { MAX_FRIEND_COUNT } from './ruleset/friends';
import {
  incrementScore,
  incrementTokenCreationCredits,
} from './game.modifiers';

export const gameMessages = createMessages(schema)({
  addFriend: createMessage(
    SB.object({
      friendId: SB.string(),
      bonus: SB.int(),
    }),
    (state, { friendId, bonus }, info) => {
      // if friend alread exists, we dont want to add bonuses
      if (state.friendIds.includes(friendId)) {
        return;
      }

      // the player cannot have more than a given amount of friends
      // but can still receive bonuses from referrals
      if (state.friendIds.length < MAX_FRIEND_COUNT) {
        state.friendIds.push(friendId);
      }

      incrementScore(state, bonus);
    },
  ),
  addReferrerScore: createMessage(
    SB.object({ bonus: SB.int() }),
    (state, { bonus }, info) => {
      incrementScore(state, bonus);
    },
  ),
  addUnclaimedReferrerScore: createMessage(
    SB.object({ rewards: SB.int() }),
    (state, { rewards }, info) => {
      state.unclaimed_referral_rewards += rewards;
    },
  ),
  claimRewards: createMessage(
    SB.object({ rewards: SB.int() }),
    (state, { rewards }, info) => {
      incrementScore(state, rewards);
    },
  ),
  follow: createMessage(SB.object({}), (state, {}, info) => {
    state.followersCount++;
  }),
  unfollow: createMessage(SB.object({}), (state, {}, info) => {
    state.followersCount--;
  }),
  // Deprecates
  // @deprecated
  addFriendContribution: createMessage(SB.unknown(), (state, _, info) => {}),
  // @deprecated
  transferFriends: createMessage(SB.unknown(), (state, _, info) => {}),
  // Admin messages
  addRewards: createAdminMessage(
    SB.object({ rewards: SB.int() }),
    (state, { rewards }, info) => {
      incrementScore(state, rewards);
    },
  ),
  addTokenCredits: createAdminMessage(
    SB.object({ credits: SB.int() }),
    (state, { credits }, info) => {
      incrementTokenCreationCredits(state, credits);
    },
  ),
});
